document.addEventListener('DOMContentLoaded', () => {
  const reveal = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        reveal.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px' });

  document.querySelectorAll('.tz-reveal').forEach((element) => reveal.observe(element));

  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-tz-media]');
    if (thumb) {
      const gallery = thumb.closest('[data-tz-gallery]');
      const main = gallery?.querySelector('#TzProductMainImage');
      if (main && thumb.dataset.tzMedia) {
        main.src = thumb.dataset.tzMedia;
        main.srcset = '';
        gallery.querySelectorAll('[data-tz-media]').forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
      }
    }

    const quantityButton = event.target.closest('[data-quantity-change]');
    if (quantityButton) {
      const form = quantityButton.closest('[data-tz-product-form]');
      const input = form?.querySelector('input[name="quantity"]');
      if (input) {
        const next = Math.min(99, Math.max(1, Number(input.value || 1) + Number(quantityButton.dataset.quantityChange)));
        input.value = String(next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    const wishlist = event.target.closest('[data-tz-wishlist]');
    if (wishlist) {
      const active = wishlist.getAttribute('aria-pressed') !== 'true';
      wishlist.setAttribute('aria-pressed', String(active));
      wishlist.setAttribute('aria-label', active ? 'Usuń produkt z ulubionych' : 'Dodaj produkt do ulubionych');
      try {
        const saved = new Set(JSON.parse(localStorage.getItem('top-zwierzak-wishlist') || '[]'));
        active ? saved.add(wishlist.dataset.tzWishlist) : saved.delete(wishlist.dataset.tzWishlist);
        localStorage.setItem('top-zwierzak-wishlist', JSON.stringify([...saved]));
      } catch (_) {}
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-bundle-quantity]')) {
      const form = event.target.closest('[data-tz-product-form]');
      const quantity = form?.querySelector('input[name="quantity"]');
      if (quantity) quantity.value = event.target.dataset.bundleQuantity;
    }
    if (event.target.matches('input[name="quantity"]')) {
      const form = event.target.closest('[data-tz-product-form]');
      const bundle = form?.querySelector(`[data-bundle-quantity="${event.target.value}"]`);
      form?.querySelectorAll('[data-bundle-quantity]').forEach((option) => { option.checked = option === bundle; });
    }
  });

  try {
    const saved = new Set(JSON.parse(localStorage.getItem('top-zwierzak-wishlist') || '[]'));
    document.querySelectorAll('[data-tz-wishlist]').forEach((button) => {
      const active = saved.has(button.dataset.tzWishlist);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? 'Usuń produkt z ulubionych' : 'Dodaj produkt do ulubionych');
    });
  } catch (_) {}

  document.querySelectorAll('[data-tz-countdown]').forEach((countdown) => {
    const output = countdown.querySelector('[data-tz-countdown-output]');
    const cycle = Number(countdown.dataset.cycleDays || 7) * 86400000;
    const getEnd = () => {
      if (countdown.dataset.countdownMode !== 'weekly') return new Date(countdown.dataset.endDate || '').getTime();
      const anchor = new Date(countdown.dataset.cycleAnchor || '').getTime();
      if (!Number.isFinite(anchor) || !Number.isFinite(cycle) || cycle <= 0) return NaN;
      if (Date.now() < anchor) return anchor;
      return anchor + (Math.floor((Date.now() - anchor) / cycle) + 1) * cycle;
    };
    const tick = () => {
      const end = getEnd();
      const remaining = end - Date.now();
      if (!Number.isFinite(end) || remaining <= 0) {
        countdown.classList.remove('is-visible');
        return;
      }
      countdown.classList.add('is-visible');
      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);
      output.innerHTML = `<span>${days} d</span><span>${hours} godz.</span><span>${minutes} min</span><span>${seconds} s</span>`;
    };
    tick();
    window.setInterval(tick, 1000);
  });

  document.querySelectorAll('[data-tz-sticky-buy]').forEach((stickyBar) => {
    const section = stickyBar.closest('.shopify-section');
    const primaryPurchase = section?.querySelector('[data-tz-primary-purchase]');
    const primaryAddButton = section?.querySelector('.tz-add[type="submit"]');
    const variantSelect = section?.querySelector('select[name="id"]');
    const footer = document.querySelector('footer');
    if (!primaryPurchase || !primaryAddButton) return;

    let purchasePassed = false;
    let footerNearby = false;
    const setVisibility = () => {
      const visible = purchasePassed && !footerNearby && !primaryAddButton.disabled;
      stickyBar.classList.toggle('is-visible', visible);
      stickyBar.setAttribute('aria-hidden', String(!visible));
      stickyBar.inert = !visible;
    };

    const purchaseObserver = new IntersectionObserver(([entry]) => {
      if (!entry) return;
      purchasePassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      setVisibility();
    }, { threshold: 0 });
    purchaseObserver.observe(primaryPurchase);

    if (footer) {
      const footerObserver = new IntersectionObserver(([entry]) => {
        if (!entry) return;
        footerNearby = entry.isIntersecting;
        setVisibility();
      }, { rootMargin: '180px 0px 0px 0px' });
      footerObserver.observe(footer);
    }

    stickyBar.querySelector('[data-tz-sticky-submit]')?.addEventListener('click', () => primaryAddButton.click());

    variantSelect?.addEventListener('change', () => {
      const selectedOption = variantSelect.selectedOptions[0];
      if (!selectedOption) return;
      const variantLabel = stickyBar.querySelector('[data-tz-sticky-variant]');
      const priceLabel = stickyBar.querySelector('[data-tz-sticky-price]');
      if (variantLabel) variantLabel.textContent = selectedOption.dataset.variantTitle || '';
      if (priceLabel && selectedOption.dataset.variantPrice) priceLabel.textContent = selectedOption.dataset.variantPrice;
    });
  });
});
